import { render } from "./signDetail.vue?vue&type=template&id=78d4f93f"
import script from "./signDetail.vue?vue&type=script&lang=js"
export * from "./signDetail.vue?vue&type=script&lang=js"

import "./signDetail.vue?vue&type=style&index=0&id=78d4f93f&lang=scss"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__